module.exports = __webpack_public_path__ + "static/media/certificado.e13adbb8.png";